import { DatePicker } from "antd";
import {
  Calendar,
  // FileText,
  PlusCircle,
  Sliders,
  StopCircle,
  // StopCircle,
  User,
} from "feather-icons-react/build/IconComponents";
import React, { useState } from "react";
import { Filter } from "react-feather";
import { Link } from "react-router-dom";
import Select from "react-select";
import useSales from "../../controllers/useSales";
import usePermissions from "../../core/hooks/usePermissions";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import AddSales from "../../core/modals/sales/addsales";
import EditSales from "../../core/modals/sales/editsales";
import ViewSales from "../../core/modals/sales/viewsales";
import Table from "../../core/pagination/datatable";
import TableTop from "../../core/tabletop";
import {
  currencyFormatter,
  dateFormatter,
  getSelectedStoreDetails,
  normalizeText,
} from "../../utils/helperFunctions";
import { LIST_BRANDS, LIST_CUSTOMER } from "../../apollo/queries";
import Dropdown from "../components/Dropdown";
import { all_routes } from "../../Router/all_routes";

const SalesList = () => {

  const { canAdd, canEdit, canDelete } = usePermissions();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editKey, setEditKey] = useState(0);

  const {
    values: {
      data,
      total,
      loading,
      representatives,
      search,
      sort,
      pageValues,
      sort_values,
      selectedFromDate,
      selectedToDate,
      selectedRep,
      statusList,
      selectedStatus,
      products,
      selectedProduct,
      selectedCustomer,
      selectedBrand
    },
    states: {
      setSelectedFromDate,
      setSelectedToDate,
      setSelectedRep,
      setSelectedStatus,
      setSelectedProduct,
      setSelectedCustomer,
      setSelectedBrand
    },
    functions: {
      onChange,
      handlePageChange,
      onRefresh,
      downloadInvoice,
      downloadPackingList,
      onCancel,
      onChangeSort,
    },
  } = useSales();

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Invoice No.",
      dataIndex: "invoice_no",
      render: (value) => <p className="fw-bold">{`#${value}`}</p>,
    },
    {
      title: "Ref No.",
      dataIndex: "reference_no",
      render: (value) => `${value || "-"}`,
    },
    {
      title: "Customer Name",
      dataIndex: "full_name",
      render: (_, record) => record.customer.full_name,
    },
    {
      title: "Date",
      dataIndex: "sale_date",
      render: (text) => dateFormatter(text),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <span
          className={`badges ${text === "Completed"
            ? "bg-lightgreen"
            : text === "InProgress"
              ? "bg-lightyellow"
              : "bg-lightred"
            }`}
        >
          {normalizeText(text)}
        </span>
      ),
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      render: (total_amount) => currencyFormatter(total_amount),
    },
    {
      title: "Paid Amount",
      dataIndex: "paid",
      render: (paid) => currencyFormatter(paid),
    },
    {
      title: "Due Amount",
      dataIndex: "due",
      render: (due) => currencyFormatter(due),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      render: (text) => (
        <span
          className={`badge ${text === "Paid" ? "badge-linesuccess" : "badge-linedanger"
            }`}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Biller",
      dataIndex: "full_name",
      render: (_, record) => record.user.full_name,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, item) => (
        <div className="text-center">
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                onClick={() => {
                  setSelectedRow(item);
                  setEditKey((prev) => prev + 1);
                }}
                className="dropdown-item"
                data-bs-toggle="modal"
                data-bs-target="#sales-details-new"
              >
                <i data-feather="eye" className="feather-eye me-2"></i>Sale
                Detail
              </Link>
            </li>
            {item?.status !== "Cancelled" && (
              <>
                {canEdit && (
                  <li>
                    <Link
                      className="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#edit-sales-new"
                      onClick={() => {
                        setSelectedRow(item);
                        setEditKey((prev) => prev + 1);
                      }}
                    >
                      <i data-feather="edit" className="feather-edit me-2"></i>
                      Edit Sale
                    </Link>
                  </li>
                )}
                <li>
                  <Link
                    className="dropdown-item"
                    onClick={() => downloadInvoice(item.id)}
                  >
                    <i
                      data-feather="download"
                      className="feather-download me-2"
                    ></i>
                    Download Invoice
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    onClick={() => downloadPackingList(item.id)}
                  >
                    <i
                      data-feather="printer "
                      className="feather-printer me-2"
                    ></i>
                    Print Packing List
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to={all_routes.addsales}
                    state={{ id: item.id }}
                  // data-bs-toggle="modal"
                  // data-bs-target="#add-sales-new"
                  // onClick={() => {
                  //   setSelectedRow(item);
                  //   setEditKey((prev) => prev + 1);
                  // }}
                  >
                    <i
                      data-feather="copy"
                      className="feather-copy me-2"
                    ></i>
                    Make a Copy
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className="dropdown-item"
                    to={all_routes.salesreturn}
                    state={{ id: item.id }}
                  >
                    <i
                      data-feather="corner-down-left"
                      className="feather-corner-down-left me-2"
                    ></i>
                    Returns
                  </Link>
                </li> */}
                {canDelete && (
                  <li>
                    <Link
                      className="dropdown-item confirm-text mb-0"
                      onClick={() => onCancel(item.id)}
                    >
                      <i
                        data-feather="trash-2"
                        className="feather-trash me-2"
                      ></i>
                      Cancel Sale
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Sales List</h4>
                <h6>Manage Your Sales</h6>
              </div>
            </div>
            <TableTop onRefresh={onRefresh} />
            <div className="page-btn">
              {canAdd && (
                <Link
                  to={all_routes.addsales}
                  className="btn btn-added"
                // data-bs-toggle="modal"
                // data-bs-target="#add-sales-new"
                >
                  <PlusCircle className="me-2" />
                  Add New Sales
                </Link>
              )}
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      aria-controls="DataTables_Table_0"
                      value={search}
                      onChange={(e) => onChange(e.target.value)}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <div className="d-flex align-items-center">
                    <div className="search-path">
                      <Link
                        className={`btn btn-filter ${isFilterVisible ? "setclose" : ""
                          }`}
                        id="filter_search"
                      >
                        <Filter
                          className="filter-icon"
                          onClick={toggleFilterVisibility}
                        />
                        <span onClick={toggleFilterVisibility}>
                          <ImageWithBasePath
                            src="assets/img/icons/closes.svg"
                            alt="img"
                          />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="form-sort">
                  <Sliders className="info-img" />
                  <Select
                    className="img-select"
                    classNamePrefix="react-select"
                    options={sort_values}
                    placeholder="Select Sort"
                    isSearchable={false}
                    value={sort}
                    onChange={onChangeSort}
                    isClearable
                  />
                </div>
              </div>
              {/* /Filter */}
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div>
                        <Dropdown
                          field={{ value: selectedCustomer?.value }}
                          query={LIST_CUSTOMER}
                          dataKey="listCustomer"
                          variables={{
                            storeId: getSelectedStoreDetails("id"),
                          }}
                          placeholder="Select a Customer"
                          onChange={setSelectedCustomer}
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div>
                        <Dropdown
                          field={{ value: selectedBrand?.value }}
                          query={LIST_BRANDS}
                          dataKey={"listBrand"}
                          variables={{
                            storeId: getSelectedStoreDetails("id"),
                          }}
                          placeholder="Select a Brand"
                          onChange={setSelectedBrand}
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div>
                        <Select
                          classNamePrefix="react-select"
                          options={products}
                          value={selectedProduct}
                          onChange={setSelectedProduct}
                          placeholder="Select Product"
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <i data-feather="user" className="info-img" />
                        <User className="info-img" />
                        <Select
                          className="img-select"
                          classNamePrefix="react-select"
                          options={representatives}
                          value={selectedRep}
                          onChange={setSelectedRep}
                          placeholder="Select Representative"
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <i data-feather="stop-circle" className="info-img" />
                        <StopCircle className="info-img" />
                        <Select
                          className="img-select"
                          classNamePrefix="react-select"
                          options={statusList?.map((x) => ({
                            label: x,
                            value: x,
                          }))}
                          placeholder="Choose Status"
                          value={selectedStatus}
                          onChange={setSelectedStatus}
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <div className="input-groupicon calender-input">
                          <Calendar className="info-img" />
                          <DatePicker
                            selected={selectedFromDate}
                            onChange={(date) => {
                              console.log("date", date);
                              setSelectedFromDate(date);
                            }}
                            // onChange={handleDateChange}
                            type="date"
                            className="filterdatepicker"
                            dateFormat="dd-MM-yyyy"
                            placeholder="Choose From Date"
                          />
                        </div>
                        {/* <StopCircle className="info-img" />
                        <Select
                          className="img-select"
                          classNamePrefix="react-select"
                          options={status}
                          placeholder="Newest"
                        /> */}
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <div className="input-groupicon calender-input">
                          <Calendar className="info-img" />
                          <DatePicker
                            selected={selectedToDate}
                            onChange={(date) => {
                              setSelectedToDate(date);
                            }}
                            type="date"
                            className="filterdatepicker"
                            dateFormat="dd-MM-yyyy"
                            placeholder="Choose To Date"
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-lg-3 col-sm-6 col-12"> */}
                    {/* <div className="input-blocks">
                        <StopCircle className="info-img" />
                        <Select
                          className="img-select"
                          classNamePrefix="react-select"
                          options={paymentstatus}
                          placeholder="Choose Payment Status"
                        />
                      </div> */}
                    {/* </div> */}
                    {/* <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Link className="btn btn-filters ms-auto">
                          {" "}
                          <i
                            data-feather="search"
                            className="feather-search"
                          />{" "}
                          Search{" "}
                        </Link>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              {/* /Filter */}
              <div className="table-responsive">
                <Table
                  total={total}
                  loading={loading}
                  columns={columns}
                  onPageChange={handlePageChange}
                  pagination={pageValues}
                  dataSource={data || []}
                />
                {/* <Table columns={columns} dataSource={filteredData} /> */}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <>
        <AddSales id={selectedRow?.id} refetch={onRefresh} downloadInvoice={downloadInvoice} />
        <EditSales refetch={onRefresh} rowData={selectedRow} editKey={editKey} />
        <ViewSales id={selectedRow?.id} downloadInvoice={downloadInvoice} />
      </>
    </div>
  );
};

export default SalesList;
